import { render, staticRenderFns } from "./vehiclesMainView.vue?vue&type=template&id=22efaffc&scoped=true&"
import script from "./vehiclesMainView.vue?vue&type=script&lang=js&"
export * from "./vehiclesMainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22efaffc",
  null
  
)

export default component.exports